import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgSuitcase = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#Suitcase_svg__a)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.65,
        d: "M45.995 11.851H2.005A2.005 2.005 0 0 0 0 13.856v27.756c0 1.107.898 2.005 2.005 2.005h43.99A2.005 2.005 0 0 0 48 41.612V13.856a2.005 2.005 0 0 0-2.005-2.005Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M13.323 11.146h-2.165a.594.594 0 0 0-.594.593v31.99c0 .328.266.593.594.593h2.165a.594.594 0 0 0 .593-.593v-31.99a.594.594 0 0 0-.593-.594Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.65,
        d: "M10.628 10.44h3.222c.33 0 .594.267.594.593v3.273c0 .788-.64 1.427-1.427 1.427h-1.558c-.787 0-1.427-.64-1.427-1.427v-3.273c0-.329.267-.593.594-.593h.002Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.85,
        d: "M12.327 14.674a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M36.844 11.146H34.68a.594.594 0 0 0-.593.593v31.99c0 .328.266.593.593.593h2.165a.594.594 0 0 0 .594-.593v-31.99a.594.594 0 0 0-.594-.594Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.65,
        d: "M34.15 10.44h3.222c.329 0 .594.267.594.593v3.273c0 .788-.64 1.427-1.428 1.427h-1.557c-.788 0-1.427-.64-1.427-1.427v-3.273c0-.329.267-.593.593-.593h.003Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.85,
        d: "M35.849 14.674a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412ZM30.676 11.85h-2.055V7.593a.538.538 0 0 0-.539-.537h-8.164a.54.54 0 0 0-.539.537v4.259h-2.055V7.59A2.595 2.595 0 0 1 19.918 5h8.164a2.596 2.596 0 0 1 2.594 2.592v4.259Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx("g", { opacity: 0.75, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M17.146 10.595h2.292c.217 0 .396.178.396.395v.86H16.75v-.86c0-.217.179-.395.396-.395ZM28.564 10.595h2.293c.217 0 .395.178.395.395v.86h-3.083v-.86c0-.217.178-.395.395-.395Z" }) }),
    /* @__PURE__ */ jsx("g", { opacity: 0.65, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M5.332 12.57A4.797 4.797 0 0 1 0 17.336v-3.48c0-1.107.897-2.005 2.005-2.005H5.28c.034.235.052.475.052.72ZM5.447 43.285c0 .112-.005.222-.014.332H2.005A2.005 2.005 0 0 1 0 41.611v-3.077a4.797 4.797 0 0 1 5.447 4.75ZM48 13.856v3.464a4.795 4.795 0 0 1-5.392-5.47h3.387c1.108.001 2.005.899 2.005 2.006ZM48 38.52v3.091a2.005 2.005 0 0 1-2.005 2.006h-3.311A4.795 4.795 0 0 1 48 38.52Z" }) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "m40.574 26.937-11.547-.773a.279.279 0 0 0-.297.26l-.297 4.44a.279.279 0 0 0 .26.297l11.547.773a.279.279 0 0 0 .296-.26l.298-4.44a.279.279 0 0 0-.26-.297ZM33.218 22.292l-.28.454-.012.535-.489.228-.222.486-.534.078-.322.43-.539-.015-.381.38-.532-.083-.423.334-.52-.135-.453.292-.507-.182-.477.25-.486-.225-.498.208-.466-.272-.514.155-.434-.322-.53.09-.38-.38-.54-.002-.288-.452-.516-.158-.084-.525-.34-.411.28-.455.012-.534.486-.228.224-.487.532-.077.325-.43.536.016.381-.381.533.082.422-.333.52.134.453-.292.51.183.474-.251.489.226.498-.208.463.272.516-.156.432.322.532-.089.38.38.538.002.29.452.514.157.084.526.343.41ZM16.015 38.376a3.681 3.681 0 1 0 0-7.363 3.681 3.681 0 0 0 0 7.363ZM10.678 28.296l-7.247 1.56a.16.16 0 0 0-.123.189l.94 4.371a.16.16 0 0 0 .19.123l7.247-1.559a.16.16 0 0 0 .123-.19l-.94-4.371a.16.16 0 0 0-.19-.123Z",
        fill: "#65BFF1"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "Suitcase_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", transform: "translate(0 5)", d: "M0 0h48v39.322H0z" }) }) })
] });
const ForwardRef = forwardRef(SvgSuitcase);
export {
  ForwardRef as default
};
